module.exports = __webpack_public_path__ + "static/img/Gradient.5be4e6cd.png";